// extracted by mini-css-extract-plugin
export default {"wrapper":"AX","product_img":"BX","info":"CX","image":"EX","remove_btn":"FX"};
    if(module.hot) {
      // 1713211526262
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  